// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@steiner/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { customerPartNumbersStyles } from "@steiner/App/Widgets/CustomerPartNumbers/HomeCustomerPartNumbers";
import Copy from "@steiner/XDL/Icons/Copy";
import { css } from "styled-components";

customerPartNumbersStyles.downloadLinksWrapper = {
    css: css`
        display: flex;
        justify-content: end;
        gap: 12px;
        margin-bottom: 12px;
    `,
};

customerPartNumbersStyles.csvFileLink = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
    icon: {
        position: "left",
        iconProps: {
            src: Copy,
            size: 14,
            css: css`
                margin-right: 6px;
                &,
                & svg {
                    height: 13px;
                }
            `,
        },
    },
};

customerPartNumbersStyles.textFileLink = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
    icon: {
        position: "left",
        iconProps: {
            src: Copy,
            size: 14,
            css: css`
                margin-right: 6px;
                &,
                & svg {
                    height: 13px;
                }
            `,
        },
    },
};

customerPartNumbersStyles.notFoundMessage = {
    ...dataTableStyles.noResultsText,
};

customerPartNumbersStyles.tableStyles = {
    css: css`
        p[class^="HeaderTypography"] {
            white-space: nowrap;
        }
    `,
};
